import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './WorkspaceSignupView.module.css'
import { Button } from '@/components/Button'
import { ButtonGroup } from '@/components/ButtonGroup'

export interface WorkspaceSignupViewProps {
  workspaceLogoUrl: string
  workspaceName: string
  children: ReactNode
  isPending: boolean
  isLogoutVisible: boolean
  onLogout: () => void
  formId?: string
  testId?: string
  continueButtonTestId?: string
  logoutButtonTestId?: string
}

export function WorkspaceSignupView({
  workspaceLogoUrl,
  workspaceName,
  children,
  isPending,
  isLogoutVisible,
  onLogout,
  formId,
  testId,
  continueButtonTestId,
  logoutButtonTestId,
}: WorkspaceSignupViewProps) {
  return (
    <div className={cx(styles.root)} data-test={testId}>
      <div className={styles.container}>
        <div className="mb-3xl">
          <img
            className={styles.workspaceLogo}
            src={workspaceLogoUrl}
            alt={`${workspaceName} logo`}
          />
        </div>
        <div className="mb-3xl text-center">
          <h1 className="text-display-lg mb-md">Tell us more about you</h1>
          <p className="text-body-md-light">
            You're one step away from gaining access.
          </p>
        </div>

        {children}

        <div className="mt-3xl">
          <ButtonGroup stacked stretch>
            <Button
              isPending={isPending}
              type="submit"
              form={formId}
              label="Continue"
              testId={continueButtonTestId}
            />
            {isLogoutVisible && (
              <Button
                type="button"
                label="Log out"
                variant="text"
                onPress={onLogout}
                isDisabled={isPending}
                testId={logoutButtonTestId}
              />
            )}
          </ButtonGroup>
        </div>
      </div>
    </div>
  )
}
